module.exports = __webpack_public_path__ + "img/item1.766d4c4c.png";